<template>
  <section class="wheelchair-intro">
    <div class="container">
      <div class="wc-intro-content">
        <div class="wc-intro-text">
          <h2 class="gradient-text">Wheelchair Product Line Advantages</h2>
          <ul class="wc-features">
            <li><span class="icon">⚡</span> Intelligent drive system, easily handles various road conditions</li>
            <li><span class="icon">🦾</span> High-strength lightweight materials, sturdy and durable</li>
            <li><span class="icon">🧒</span> Diverse adaptability, covering children, adults, and elderly</li>
            <li><span class="icon">🛡️</span> Multiple safety protections, worry-free experience</li>
            <li><span class="icon">🛠️</span> Personalized customization and comprehensive after-sales service</li>
          </ul>
          <p class="wc-desc">
            Our wheelchair products integrate cutting-edge technology with humanized design, meeting the diverse needs of different users. Whether for daily travel, rehabilitation training, or special care, we can provide you with the most suitable solutions.
          </p>
        </div>
        <div class="wc-intro-img">
          <img src="https://via.placeholder.com/320x200?text=Wheelchair+Display" alt="Wheelchair Product Line" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WheelchairIntro'
}
</script>

<style scoped>
.wheelchair-intro {
  background: #fff;
  padding: 5rem 2rem 4rem;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
}
.wc-intro-content {
  display: flex;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
}
.wc-intro-text {
  flex: 1;
  min-width: 260px;
}
.wc-intro-text h2 {
  font-size: 2.2rem;
  margin-bottom: 1.2rem;
  font-weight: 700;
}
.wc-features {
  list-style: none;
  padding: 0;
  margin-bottom: 1.2rem;
  color: #2c5aa0;
  font-size: 1.08rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.wc-features .icon {
  margin-right: 0.5rem;
  font-size: 1.2rem;
}
.wc-desc {
  color: #555;
  font-size: 1.08rem;
  line-height: 1.7;
}
.wc-intro-img img {
  width: 320px;
  max-width: 100%;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(44,90,160,0.10);
  background: #f6f8fa;
}
@media (max-width: 900px) {
  .wc-intro-content {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 2rem;
  }
  .wc-intro-img img {
    margin-bottom: 1rem;
  }
}
</style> 